import { Fragment } from 'react';

/* Brand treatment for the IQ service names: the "IQ" renders as smaller
   superscript characters, tinted Triton blue, slightly above the main word
   (e.g. lead·IQ, traffic·IQ, tritonIQ Dashboard). Wraps any string and
   superscripts each "<word>IQ" token; other text passes through unchanged. */
export function IqName({ text, className = '' }: { text: string; className?: string }) {
  const parts = text.split(/([A-Za-z]+IQ)\b/g);
  return (
    <span className={`iq ${className}`.trim()}>
      {parts.map((p, i) => {
        const m = /^([A-Za-z]+)IQ$/.exec(p);
        return m
          ? <Fragment key={i}>{m[1]}<sup className="iq__pow">IQ</sup></Fragment>
          : <Fragment key={i}>{p}</Fragment>;
      })}
    </span>
  );
}
